import script from "./programme.vue?vue&type=script&setup=true&lang=ts"
export * from "./programme.vue?vue&type=script&setup=true&lang=ts"

import "./programme.vue?vue&type=style&index=0&id=b8715638&lang=scss"

const __exports__ = script;

export default __exports__